import UnderConstructionPage from './UnderConstructionPage';

export default UnderConstructionPage;
